// DEV-321: keep users on the current bundle after a deploy.
//   - appUpdateWatcher: polls /version.json, reloads or shows a toast
//   - chunkRecovery:    one reload when a lazy chunk fails to load
// Production builds only: in dev Vite's HMR already handles both.
import { startUpdateWatcher } from "./appUpdateWatcher";
import { installChunkLoadRecovery } from "./chunkRecovery";

export { lazyWithReload } from "./lazyWithReload";
export {
  subscribeUpdateToast,
  getUpdateToastState,
  dismissUpdateToast,
  reloadForUpdate,
  onClientNavigation,
} from "./appUpdateWatcher";

export function startAppVersionWatcher(): void {
  if (!import.meta.env.PROD) return;
  installChunkLoadRecovery();
  startUpdateWatcher();
}
